import React, {useState} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {httpsCallable} from 'firebase/functions';
import {functions} from '../firebase';

type InviteResult = {sent?: boolean; sendError?: string | null; manualUrl?: string};

export default function BrokerApprovalActions({brokerId, compact = false}: {
  brokerId: string;
  compact?: boolean;
}) {
  const [busy, setBusy] = useState('');
  const [message, setMessage] = useState('');
  const [manualUrl, setManualUrl] = useState('');

  const decide = async (decision: 'approve' | 'reject') => {
    setBusy(decision);
    setMessage('');
    setManualUrl('');
    try {
      await httpsCallable(functions, 'brokerApprovalReview')({brokerId, decision});
    } catch (error: any) {
      setMessage(error?.message || 'Could not update this broker.');
    } finally {
      setBusy('');
    }
  };

  const approveAndSend = async () => {
    setBusy('send');
    setMessage('');
    setManualUrl('');
    try {
      const invite = (await httpsCallable(functions, 'brokerProfileInvite')({brokerId})).data as InviteResult;
      if (!invite.sent) {
        setMessage(invite.sendError || 'WhatsApp could not send the profile form.');
        setManualUrl(invite.manualUrl || '');
        return;
      }
      await httpsCallable(functions, 'brokerApprovalReview')({brokerId, decision: 'approve'});
    } catch (error: any) {
      setMessage(error?.message || 'Could not approve and send the profile form.');
    } finally {
      setBusy('');
    }
  };

  return <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
    <Box sx={{display: 'flex', gap: 0.75, flexWrap: 'wrap'}}>
      <Button size="small" variant="contained" disabled={!!busy} onClick={approveAndSend}
        sx={{textTransform: 'none', borderRadius: 999}}>
        {busy === 'send' ? 'Sending…' : 'Approve & send form'}
      </Button>
      <Button size="small" variant="outlined" disabled={!!busy} onClick={() => decide('approve')}
        sx={{textTransform: 'none', borderRadius: 999}}>
        {busy === 'approve' ? 'Approving…' : compact ? 'Approve only' : 'Approve without sending'}
      </Button>
      <Button size="small" color="error" disabled={!!busy} onClick={() => decide('reject')}
        sx={{textTransform: 'none', borderRadius: 999}}>
        {busy === 'reject' ? 'Rejecting…' : 'Reject'}
      </Button>
    </Box>
    {message && <Typography role="status" sx={{fontSize: 12, color: manualUrl ? '#8a5317' : '#b3261e'}}>
      {message}
    </Typography>}
    {manualUrl && <Button size="small" href={manualUrl} target="_blank" rel="noopener noreferrer"
      sx={{textTransform: 'none', px: 0}}>Open prepared WhatsApp message</Button>}
  </Box>;
}
